<template>
  <v-flex>
      <v-dialog v-model="dialog" width="90%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Concordância e veracidade</v-card-title>
          <v-card-text>
            A realização do registro como fornecedor (pessoa física ou jurídica, nacional ou estrangeira) ativo no Cadastro Unificado de Fornecedores do Estado da Bahia - CAF e a entrega deste documento, importa na aceitação de todos os termos e condições que regem o Cadastro Unificado de Fornecedores do Estado da Bahia - CAF, conforme Lei Estadual nº 9.433, de 01 de março de 2005 e demais instrumentos legais vigentes, admitindo como válida a assinatura eletrônica cadastrada (login/senha).
            <br><br>
            Ao submeter a solicitação, o fornecedor (pessoa física ou jurídica, nacional ou estrangeira) admite-se como responsável pelas ações efetuadas no Comprasnet.BA, bem como atesta a veracidade de todos os documentos enviados, concordando em que havendo condutas suspeitas de irregularidades, as mesmas serão passíveis de apuração de ilícito civil, penal e administrativo.
            <br><br>
            Ainda, declara que o endereço informado refere-se a atual localização do fornecedor (pessoa física ou jurídica, nacional ou estrangeira), e assume exclusivamente a responsabilidade por:
            <br><br>
            I.  Manter em sigilo a senha de acesso, não cabendo, em qualquer hipótese, alegação de uso indevido;
            <br>
            II.  Conformidade entre os dados informados no formulário de solicitação de cadastro e os constantes do documento protocolizado, incluindo o preenchimento dos campos obrigatórios e anexação dos documentos essenciais complementares;
            <br>
            III.  Preenchimento da solicitação do cadastro e o upload dos documentos digitais em conformidade com os requisitos estabelecidos pelo Sistema, no que se refere ao formato e ao tamanho dos arquivos transmitidos eletronicamente;
            <br>
            IV.  Manutenção das vias originais dos documentos digitalizados enviados na solicitação do cadastro eletrônico, para que, caso solicitado, sejam apresentados para qualquer tipo de conferência pela Administração;
            <br>
            V.  Realização por meio eletrônico de todas as atualizações e comunicações entre o órgão/entidade responsável e o usuário, não sendo admitidas protocolização por meio diverso, exceto nas situações em que for tecnicamente inviável ou em caso de indisponibilidade do meio eletrônico cujo prolongamento cause dano relevante à celeridade do processo ou outra exceção prevista em instrumento normativo próprio;
            <br>
            VI.  Acompanhamento, por meio do protocolo eletrônico da solicitação do cadastro e/ou atualização dos documentos transmitidos eletronicamente;
            <br>
            VII.  Assumir as condições de navegabilidade e segurança da rede de comunicação, o acesso ao provedor de internet e as configurações do computador utilizado nas transmissões eletrônicas;

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="dialog = false">Eu aceito</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogApresentacao" width="90%" :persistent="persistente" >
        <v-card>
          <v-card-title class="headline grey lighten-2">Apresentação</v-card-title>
          <v-card-text>              
            <h2><b>Bem-Vindo ao Cadastro Unificado de Fornecedores do Estado da Bahia – CAF</b></h2>	
            <br />
            <p style="text-align:justify;">                
              O Cadastro Unificado de Fornecedores do Estado da Bahia - CAF é um sistema informatizado que gerencia, mantém e controla, de forma unificada, o cadastro de fornecedores. Atualmente o CAF é gerido pela Superintendência de Recursos Logísticos por intermédio da Coordenação de Gestão do Cadastro de Fornecedores – CGCF/DSL/SRL a qual compõe a estrutura da Secretaria da Administração do Estado da Bahia – SAEB.
              <br /><br />
              A Comissão de Cadastro tem a função de proceder ao exame dos documentos apresentados por pessoas físicas ou jurídicas interessadas em participar de licitações e celebrar contratos com os órgãos e entidades da Administração Pública Estadual para manutenção do CAF, visando proporcionar maior celeridade na habilitação nos procedimentos licitatórios, e subsidiar os órgãos/entidades nas contratações.
              <br /><br />
              O CAF disponibiliza três opções de inscrição conforme segue:
              <br /><br />
              1.<b> Certificado de Registro Cadastral – CRC</b>: Certificado que pré-habilita, de forma genérica, o fornecedor a participar de qualquer modalidade de licitação, desde que possua o código de família exigido no edital.  
              <br />
              <br />
              2.<b> Certificado de Registro Simplificado – CRS</b>: Certificado que pré-habilita, de forma genérica, o fornecedor a participar de licitação, desde que possua o código de família exigido no edital, fazendo-se necessária a apresentação de documentação complementar, a depender da modalidade de licitação. 
              <br />
              <br />
              3.<b> Credenciamento para Cotação Eletrônica (Candidato)</b>: Procedimento que autoriza e credencia o fornecedor para participar de cotações eletrônicas.
                              
            </p>	
          </v-card-text>
          <v-card-title class="headline grey lighten-2">Identificação do Representante Legal</v-card-title>
          <v-card-text>
            <v-form v-model="valid" lazy-validation ref="formCadastrador" persistent>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="50" v-model="model.nome" :label="$t('label.nome') + ' *' " :rules="validacao.campoObrigatorio" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field v-if="model.flagEstrangeiro == 1" v-model="model.cpfCadastrador" :label="$t('label.passaporte')+' *' " v-mask="maskDocumentoIdentificacao" maxlength="14" :rules="validacao.campoObrigatorio" required></v-text-field>
                  <v-text-field v-else v-model="model.cpfCadastrador" :label="$t('label.cpf')+' *' "  v-mask="maskCpf"  :rules="validacao.cpf" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field v-model="model.rg" :label="$t('label.documentoIdentificacao') + ' (' + $t('label.documentosValidosIdentificacao') + ') *'" v-mask="maskAlfaNumRG" :rules="validacao.campoObrigatorio" required> </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="50" v-model="model.email" :label="$t('label.email') + ' *'" :rules="validacao.email" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row  v-show="model.tipFornecedor =='J'">
                <v-flex xs12>
                  <v-text-field maxlength="140" v-model="model.razaO_SOCIAL" :label="$t('label.razaoSocial')">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row   v-show="model.tipFornecedor =='J'">
                <v-flex xs12>
                  <v-text-field v-model="model.cnpj" :label="$t('label.cnpj')" v-mask="maskCnpj"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- CEP com consulta ao webservice -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field 
                    v-model="model.cep"
                    :label="$t('label.cep') + ' *' "
                    v-mask="maskCEP"
                    :rules="validacao.campoObrigatorio"
                    required
                    @blur="viaCEP()"
                    @focus="limpaCEP()"
                  >
                  </v-text-field>
                  <div
                    v-if="validEventCEP"
                    class="msgCEP v-messages v-messages__message theme--light error--text"              
                  >
                    {{ this.msgCEP }}
                  </div>                  
                </v-flex>
              </v-layout>
              <!-- / CEP com consulta ao webservice -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="50" v-model="model.endereco" :label="$t('label.endereco') + ' *' " :rules="validacao.campoObrigatorio" required> </v-text-field>
                </v-flex>
              </v-layout> 
              <v-layout row>
                <v-flex xs12>
                  <v-text-field maxlength="100" v-model="model.bairro" :label="$t('label.bairro') + ' *' " :rules="validacao.campoObrigatorio" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-autocomplete
                    v-if="model.flagEstrangeiro != 1"
                    v-model="model.estado"
                    :items="listaEstado"
                    :label="$t('label.estado') + ' *'"
                    item-text="nom_uf"
                    item-value="cod_uf"
                    :rules="validacao.campoObrigatorio"
                    @change="listaCidade = []"
                  ></v-autocomplete>
                  <v-text-field
                    v-else
                    maxlength="50"
                    v-model="model.estado"
                    :label="$t('label.estado') + ' *'"
                    :rules="validacao.campoObrigatorio"
                  ></v-text-field>
                </v-flex>
              </v-layout>              
              <v-layout row>
                <v-flex xs12>
                  <v-autocomplete
                    v-if="model.flagEstrangeiro != 1"
                    v-model="model.cidade"
                    :items="listaCidade"
                    :label="$t('label.cidade') + (model.estado !== 'DF' ? ' *' : '')"
                    item-text="desc_municipio"
                    item-value="desc_municipio"
                    :rules="validaCidade(model.estado)"
                    :clearable="true"
                    :loading="isLoadCombo"
                    :search-input.sync="pesquisaCidade"
                  ></v-autocomplete>
                  <v-text-field
                    v-else
                    maxlength="50"
                    v-model="model.cidade"
                    :label="$t('label.cidade')"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field v-model="model.celular" :label="$t('label.celular') + ' *' " :rules="validacao.campoObrigatorio" v-mask="[maskTelefone , maskCelular]" required></v-text-field>
                </v-flex>
              </v-layout>
               <v-layout row>
                <v-flex xs12>
                  <v-text-field v-model="model.telefone" :label="$t('label.telefone')" v-mask="[maskTelefone , maskCelular]"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>       
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            
            <v-btn color="info" :disabled="disabled"  @click="salvar_representante">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
  </v-flex>
</template>

<script>
   import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
   import loginService from "../../../services/loginService";
   import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
   import Vue from "vue";
   import Print from "vue-print-nb";
   import axios from "axios";
   
   export default {
     mixins: [util],
     props:{
       dados : Object,
       aberto : Boolean,
       persistente: false,
       isAlteracao: Boolean,
     },
     data() {//Declaracao de variaveis
       return {
          valid: true,
          teste: this.dados,
          model: Object,
          num_CgcFornecedor:null,
          repitaSenha: "",
          recuperar: null,
          msgRepitaSenha: this.$t("messages.validacao.senhasDiferentes"),
          dialog: false,
          dialogApresentacao: this.aberto,
          disabled: false,
          chkPopUp: false,
          dialogPop: false,
          listaEstado: [],
          listaCidade: [],
          isLoadCombo: false,
          pesquisaCidade: null,
          baseUrlCEP: "https://viacep.com.br/ws/",
          msgCEP: "",
          validEventCEP: false,
          cepNaoEnc: "CEP não encontrado.",
       };
     },
     watch: {
      pesquisaCidade(newValor, oldValor) {
        this.pesquisaCombo(
          newValor,
          oldValor,
          "listaCidade",
          eval("this.listaCidade"),
          "model.cidade",
          this.getCidade
        );
      },
      
      "model.cidade": {
        //se a cidade mudar
        handler(newValue, oldValor) {
          if (this.model.flagEstrangeiro !== "1") {
            // flagEstrangeiro é um tipo string
            this.getCidade(newValue);
          }
        },
      },
    },
     computed: {//Campos computados
        maskEstrangeiro() {
          let str = "";
          let i = 0;
          for ( ; i < 30; i++) {
            str += "X";
          }
          return [str];
        }
      },
      created(){
        this.getCombosDadosBasicos();
        this.inicializar();
        Vue.use(Print);
      },
      methods: {
        inicializar() {
          if(this.dados.representanteLegal !=  undefined){
            this.visualizarSolicitacao(this.dados.representanteLegal.idFornecSolicitacao);
          }
          else{
            this.$mostrarPreload();
            if(this.$verificaPerfilFornecedor()){
              const numCgcFornecedor = this.$store.getters.getUsuarioId;
              fornecedorService.listarSolicitacoes(numCgcFornecedor).then(
                response => {
                  this.solicitacaoLista = response.data;
                  const id = this.solicitacaoLista[0].idFornecSolicitacao;
                  this.visualizarSolicitacao(id);
                }
              );
            } 
            this.$removePreload();
          }
        },

        visualizarSolicitacao(IdFornecSolicitacao) {
          //visualizar a solicitcao
          this.$mostrarPreload(); /*Exibir o PreLoad*/
          fornecedorService.getRepresentanteLegal(IdFornecSolicitacao).then(response => 
          { /*resposta do servico*/
              if(response.data.representanteLegal != null){
                this.model = response.data.representanteLegal; /*dados de retorno*/
                this.listaCidade.push(this.model.cidade);
              }else{
                this.model = {
                  IdFornecSolicitacao: IdFornecSolicitacao,
                };
              }
              if (this.model.tipFornecedor === "F") {
                this.model.razaO_SOCIAL = response.data.nomFornecedor;
              } else {
                this.model.cnpj = response.data.numCgcFornecedor;
                this.model.razaO_SOCIAL = response.data.nomFornecedor;
              }
              this.model.cpfCadastrador = this.model.cpf;
              this.model.flagEstrangeiro = response.data.flagEstrangeiro;
              this.model.tipFornecedor = response.data.tipFornecedor;
              this.model.num_cgc_fornecedor = response.data.numCgcFornecedor;
              
              this.$refs.formCadastrador.resetValidation();
              this.modelCarregado = true;
              this.$removePreload(); /*Ocultar o PreLoad*/

          }).catch(error => 
            {
              this.$removePreload(); /*Ocultar o PreLoad*/
              if (error.status == 403) {
                  Vue.toasted.error("Acesso não permitido!");
                  this.$router.push("/historico-solicitacoes");
              }
            }
          );
      },
      //Declaracao de todos os metodos
      salvar_representante(){
        this.dados.representanteLegal = this.model;
        if (this.$refs.formCadastrador.validate()) {       
          this.$mostrarPreload(); /*Exibir o PreLoad*/
          this.model.cpf = this.model.cpfCadastrador;
          fornecedorService.cadastrarRepresentanteLegal(this.model).then(response => { /*resposta do servico*/
              this.$emit('onSaveRepresentante', true);
              this.dialogApresentacao = false;
              this.$toasted.success(this.$t('messages.cadastro.alterado'));
              this.$router.push("/termo-declaracao-concordancia/" + response.data.fornecedorSolicitacao.idFornecSolicitacao + "/2" );
          }).catch(() => {
            this.disabled = false;
          });         
        }

       },
       cadastrar() {
         if (this.$refs.formCadastro.validate()) {
           if(this.model.flagEstrangeiro === '0'){
              //this.model.numCgcFornecedor=this.num_CgcFornecedor.replace(/[\W_]+/g, '');
           }else{
              this.model.numCgcFornecedor=this.num_CgcFornecedor;
           }

           if(this.model.tipFornecedor==="F"){
              this.model.nomFantasia=this.model.nomFornecedor;
           }
           loginService.validarcadastroinicial(this.model).then(response => { /*resposta do servico*/
              this.mostrarApresentacao();
          });
         }
       },
       mostrarApresentacao(){
        this.dialogApresentacao = true;
       },
       salvar_dado_2(){

         if (this.$refs.formCadastrador.validate()) {
          this.$mostrarPreload(); /*Exibir o PreLoad*/
          this.disabled = true;
          //this.model.cpfCadastrador = this.model.cpfCadastrador.replace(/[^\d]+/g, '');
          loginService.cadastroinicial(this.model).then(response => { /*resposta do servico*/

            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

              this.dialogApresentacao = false;
              this.$toasted.success(this.$t('messages.cadastro.alterado'));
              this.$router.push("/cadastro");

            this.disabled = false;

          }).catch(() => {
            this.disabled = false;
          });
         }
       },
       fecharApresentacao(){

         if (this.$refs.formCadastrador.validate()) {
          this.$mostrarPreload(); /*Exibir o PreLoad*/
          this.disabled = true;
          this.model.cpfCadastrador = this.model.cpfCadastrador.replace(/[^\d]+/g, '');
          loginService.cadastroinicial(this.model).then(response => { /*resposta do servico*/

            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

              this.dialogApresentacao = false;
              this.$toasted.success(this.$t('messages.cadastro.alterado'));
              this.$router.push("/cadastro");

            this.disabled = false;

          }).catch(() => {
            this.disabled = false;
          });
         }
       },
       validaSenhaIguais() {
         if (this.model.senha !== this.repitaSenha) {
           if (!this.repitaSenha) {
             this.msgRepitaSenha = this.$t("messages.validacao.campoObrigatorio")
           } else {
             this.msgRepitaSenha = this.$t("messages.validacao.senhasDiferentes")
           }
           return false
         }
         return true;
       },
       abrirTermos() {
         this.dialog = true;
       },
       abrirPopUp() {
         if(this.chkPopUp == true && this.dialog == false){
          this.dialogPop = true;
         }
       },
       getCombosDadosBasicos() {
        loginService.getCombosDadosBasicos().then((response) => {
          this.listaEstado = response.data.uf;
          this.listaPais = response.data.paises;
        });
      },
      getCidade(valor) {
        this.isLoadCombo = true;

        let cidade = { cod_uf: this.model.estadoRepresentanteLegal, desc_municipio: "" };
        
        loginService.getCidade(cidade).then((response) => {
          this.listaCidade = response.data; /*dados de retorno*/
          this.isLoadCombo = false;
        });
      },
      validaCidade(estado){
        return estado !== 'DF' ? this.validacao.campoObrigatorio : [];
      },
      limpaCEP() {
        this.validEventCEP = false
      },
      viaCEP() {
        const setCEP = this.model.cep.replace("-", "").replace(".", ""); // Removendo máscara de CEP
        const urlCEP = `${this.baseUrlCEP}${setCEP}/json/`;
        
        axios.get(urlCEP).then(resp => {
          const data = resp.data
          if (!data.erro) {
            this.model.endereco = data.logradouro,
            this.model.bairro = data.bairro,
            this.model.cidade = data.localidade,
            this.model.estado = data.uf            
          } else {            
            this.validEventCEP = true
            this.msgCEP = "CEP não encontrado";
            this.model.endereco = null,
            this.model.bairro = null,
            this.model.cidade = null,
            this.model.estado = null
          }
        }).catch(error => {
          console.error(error)
          this.validEventCEP = true;
          this.msgCEP = "CEP inválido";
          this.limpaCEP;          
        })
      }
     }
   };
</script>
<style>
.msgCEP {
  position: relative !important;
  top: -10px !important;
  margin-bottom: -13px !important;
}
</style>